var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-holidays-warning"},[_vm._v(" В период с 28.10.2021 по 07.11.2021 инвестиционная платформа SimpleEstate работает в штатном режиме, без изменений графика и выходных дней. ")])}
var staticRenderFns = []

export { render, staticRenderFns }